export default __webpack_public_path__ + "61f627ad95f7c753a7219579a2a56a2c.png";